module.exports = __webpack_public_path__ + "img/5121053_s.abca2755.jpg";